import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import React from "react";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import { AccordianStyled } from "./accordian.styles";
import classNames from "classnames";

const Accordian = (props) => {
  const {
    name,
    expanded,
    handleChange,
    heading,
    body,
    variant,
    arrowPosition = "left",
  } = props;

  const canExpand = Boolean(body);
  const isOpen = canExpand ? expanded === name : false;
  const onChange = canExpand
    ? () => (isOpen ? handleChange("") : handleChange(name))
    : undefined;

  return (
    <AccordianStyled variant={variant} arrowPosition={arrowPosition}>
      <Accordion
        expanded={expanded === name}
        onChange={() =>
          expanded === name ? handleChange("") : handleChange(name)
        }
        className={classNames({ expanded: true })}
      >
        <AccordionSummary
          expandIcon={
            canExpand ? (
              <ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />
            ) : null
          }
          expandIconPosition={arrowPosition}
          // make it look non-clickable when there's no body
          sx={{ cursor: canExpand ? "pointer" : "default" }}
        >
          {heading}
        </AccordionSummary>
        <AccordionDetails style={{ padding: "0px" }}>{body}</AccordionDetails>
      </Accordion>
    </AccordianStyled>
  );
};
export default Accordian;
